// extracted by mini-css-extract-plugin
export default {"no_deco_anchor":"StoreDownloadButton_no_deco_anchor__CpbNG","button":"StoreDownloadButton_button__SXmLi","button_image":"StoreDownloadButton_button_image__JTcXV"};